const convertToSlug = (string = '') => string.toString().toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');

export default convertToSlug
